class FostrModalDialog extends HTMLElement {
    
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ['open'];
  }

  connectedCallback() {
    let closenew = this.querySelector('button[data-modal-test="test"]');
    if (closenew) {
    closenew.addEventListener('click', () => {
      this.testFct();
    });
  }
    let secondaryClose = this.querySelector('[name="close-modal-button"]');
    this.querySelector('[name="close-modal"]').addEventListener('click', this.hide.bind(this, false));
    if(secondaryClose !== null) {
      this.querySelector('[name="close-modal-button"]').addEventListener('click', this.hide.bind(this, false));
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
    
  }

  testFctt() {

    // Obtenez les sections à rendre
    const sectionsToRender = this.getSectionsToRender();

    // Simulez un état analysé comme si vous l'aviez reçu d'une requête fetch
    const simulatedParsedState = {
        sections: {}
    };

    // Remplissez l'état simulé avec les identifiants de section
    sectionsToRender.forEach(section => {
        simulatedParsedState.sections[section.section] = document.getElementById(section.id).innerHTML;
    });
    // Appelez renderContents avec l'état simulé
    this.renderContents(sectionsToRender);
}

testFct() {
  // On ajoute un produit random à 0 de quantité pour utiliser add.js et pouvoir render le cart (à optimiser)
  const itemsArr = [{
    quantity: 0,
    id: 47343018082642
  }];

  const body = JSON.stringify({
    items: itemsArr,
    sections: this.getSectionsToRender().map(section => section.id),
    sections_url: window.location.pathname
  });

  return fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then(response => response.json())
  .then(parsedState => {
    this.renderContents(parsedState);
    this.setAttribute('data-has-charge',"true");
    setTimeout(() => {
      this.clearAllCross = document.getElementById('remove-gift-atts');
    }, 1000);
    return parsedState;
  })
  .catch(err => {
    console.error(err);
  });
}


  getSectionsToRender() {
    // Note: MAX 5 sections (or AJAX API requests will fail)
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'fostr-mini-cart-items',
        section: 'fostr-mini-cart-items',
        selector: '.shopify-section'
      },
    ];
    if (document.getElementById('fostr-mini-cart-footer')) {
      sections.push({
        id: 'fostr-mini-cart-footer',
        section: document.getElementById('fostr-mini-cart-footer').dataset.id,
        selector: '.js-contents'
      });
    }
    if (document.getElementById('fostr-mini-cart-items')) {
      sections.push({
        id: 'fostr-mini-cart-items',
        section: document.getElementById('fostr-mini-cart-items').dataset.id,
        selector: '.js-contents'
      });
    }
    return sections;
  }

  renderContents(parsedState) {
    if (!parsedState.sections) {
      return;
    }
    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

      if (!elementToReplace) {
        return;
      }
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      elementToReplace.querySelectorAll('.hide-to-animate').forEach(el => {
        el.classList.add('animate__animated', 'animate__fadeIn');
        el.addEventListener('animationend', () => {
          el.classList.remove('animate__animated', 'animate__fadeIn');
        }, { once: true });
        window.requestAnimationFrame(() => el.classList.remove('hide-to-animate'));
      });
    });
    if (!document.querySelector('#MiniCart .fostr-modal__content').classList.contains('reveal')) {
      document.getElementById('cart-icon-bubble').click();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section', hideClass) {
    let newEl = new DOMParser().parseFromString(html, 'text/html');
    newEl = newEl.querySelector(selector) || newEl;
    if (hideClass) {
      newEl.querySelectorAll(hideClass).forEach(el => el.classList.add('hide-to-animate'));
    }
    return newEl.innerHTML;
  }

  disconnectedCallback() {
  }

  attributeChangedCallback(name, oldVal, newVal) {
  }

  adoptedCallback() {
  }

  show(opener) {
    if (this.hasAttribute('hidden')) { 
      this.removeAttribute('hidden'); 
      this.offsetLeft;
    }
    this.openedBy = opener;
    this.open = true;
    document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
    fostrTrapFocus(this, this.querySelector('[role="dialog"]'));
    this.revealContent();
  }

  hide() {
    this.open = false;
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden');
    fostrRemoveTrapFocus(this.openedBy);
    this.hideContent();
    document.getElementsByClassName('burger')[0].classList.remove('open');
  }

  revealContent() {
    this.querySelector('.fostr-modal__content').classList.add('reveal');
  }

  hideContent() {
    this.querySelector('.fostr-modal__content').classList.remove('reveal');
  }


  get open() {
    return this.hasAttribute('open');
  }

  set open(val) {
    if(val) {
      this.setAttribute('open', '');
    }else {
      this.removeAttribute('open');
    }
  }

}
customElements.define('fostr-modal-dialog', FostrModalDialog);


class FostrModalOpener extends HTMLElement {
  
  constructor() {
    super();

  }

  connectedCallback() {
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      if (modal) button.classList.toggle('open');
    });
  }

  disconnectedCallback() {
  }

  attributeChangedCallback(name, oldVal, newVal) {

  }

  adoptedCallback() {
    
  }

}
customElements.define('fostr-modal-opener', FostrModalOpener);
class FostrMainMenuOpener extends HTMLElement {
  
  constructor() {
    super();

  }

  connectedCallback() {
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if(button.classList.contains('open')) {
        if (modal) modal.hide(button);
        if (modal) button.classList.remove('open');
      } else  {
        if (modal) modal.show(button);
        if (modal) button.classList.add('open');
      }
    });
  }

  disconnectedCallback() {
  }

  attributeChangedCallback(name, oldVal, newVal) {

  }

  adoptedCallback() {
    
  }

}
customElements.define('fostr-menu-opener', FostrMainMenuOpener);

class FostrConfirmButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector('button');
    button.addEventListener('click', () => {   
      // Find the closest modal dialog.
      let closestModal = this.closest('fostr-modal-dialog');
      if (closestModal) {
        // Add a 3-second delay before closing the modal.
        setTimeout(() => {
          // Close the modal by calling its `hide` method.
          closestModal.hide();
        }, 3000); // 3000 milliseconds = 3 seconds
      }
    });
  }
}

customElements.define('fostr-confirm-button', FostrConfirmButton);

customElements.define('fostr-menu-opener', FostrMainMenuOpener);

